module.exports = __webpack_public_path__ + "static/media/pynrrd_1-460w.574e0aeb.png";